import {
  getData,
  getDataAnonimously,
  postData,
  postDataAnonimously,
  postFormData,
} from "./apiCoreCalls";
import { eps } from "./eps";

export const verifyUserToken = async () => {
  try {
    const response = await getData(eps.verifyToken);
    return response;
  } catch (err) {
    console.log("ERROR upon Verifying Token : ", err);
    return null;
  }
};

export const login = async (data = {}) => {
  try {
    const response = await postDataAnonimously(eps.signIn, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating profile : ", err);
    return null;
  }
};

export const forgotPassword = async (data = {}) => {
  try {
    const response = await postDataAnonimously(eps.forgotPassword, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Forgot password : ", err);
    return null;
  }
};

export const resetPassword = async (data = {}) => {
  try {
    const response = await postDataAnonimously(eps.resetPassword, data);
    return response;
  } catch (err) {
    console.log("ERROR upon reset password : ", err);
    return null;
  }
};

export const empLogout = async () => {
  try {
    const response = await getData(eps.logout);
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const updateProfile = async (data = {}) => {
  try {
    const response = await postData(eps.updateProfile, data);
    return response;
  } catch (err) {
    console.log("ERROR upon changing password : ", err);
    return null;
  }
};

export const changePassword = async (data = {}) => {
  try {
    const response = await postData(eps.changePassword, data);
    return response;
  } catch (err) {
    console.log("ERROR upon login : ", err);
    return null;
  }
};

export const fetchDashboardData = async () => {
  try {
    const response = await getData(eps.dashboard);
    return response;
  } catch (err) {
    console.log("ERROR From APIMANAGER : ", err.response);
    return null;
  }
};

export const fetchPermissionsGrantedToUser = async (
  userId = "",
  roleId = ""
) => {
  try {
    const response = await getData(
      eps.getPermissionsGrantedToUser
        .replace("${userId}", userId)
        .replace("${roleId}", roleId)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting dashboard Data : ", err);
    return null;
  }
};

export const creatNewEmployee = async (data = {}) => {
  try {
    const response = await postData(eps.createEmployee, data);
    return response;
  } catch (err) {
    console.log("ERROR upon creating a new employee : ", err);
    return null;
  }
};

export const updateEmployee = async (id = 0, data = {}) => {
  try {
    const response = await postData(
      eps.updateEmployee.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon updating an employee : ", err);
    return null;
  }
};

export const fetchEmployeesList = async (
  page = 1,
  pageSize = 20,
  filtersString = ""
) => {
  try {
    const response = await getData(
      eps.allEmployees
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(filtersString?.length > 0 && `&${filtersString}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching employees list : ", err);
    return null;
  }
};

export const fetchEmployeeById = async (id = 0) => {
  try {
    const response = await getData(eps.employeeById.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon fetching employees by id : ", err);
    return null;
  }
};

export const deleteEmployeeById = async (id = 0) => {
  try {
    const response = await getData(eps.delEmployee.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting employees by id : ", err);
    return null;
  }
};

export const toggleEmployeeStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleEmpStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggeling employees status : ", err);
    return null;
  }
};

export const uploadProfilePic = async (id = 0, data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadImage.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon updating employees Profile picture : ", err);
    return null;
  }
};

export const uploadEmployeeDocument = async (id = 0, data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadDocument.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon uploading document : ", err);
    return null;
  }
};

export const searchEmployees = async (query = "") => {
  try {
    const response = await getData(
      eps.searchEmployees.replace("${query}", query)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Searching Employee : ", err);
    return null;
  }
};

export const checkIfEmailExists = async (data = {}) => {
  try {
    const response = await postData(eps.checkEmail, data);
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const deleteEmpDoc = async (id = "") => {
  try {
    const response = await getData(eps.deleteDocument.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};
export const fetchDepartmentsList = async () => {
  try {
    const response = await getData(eps.allDepartments);
    return response;
  } catch (err) {
    console.log("ERROR upon getting departments : ", err);
    return null;
  }
};

export const fetchAllRoles = async () => {
  try {
    const response = await getData(eps.allRoles);
    return response;
  } catch (err) {
    console.log("ERROR upon getting departments : ", err);
    return null;
  }
};

export const fetchDesignationsList = async () => {
  try {
    const response = await getData(eps.allDesignations);
    return response;
  } catch (err) {
    console.log("ERROR upon getting designations : ", err);
    return null;
  }
};

export const fetchUsersList = async (page = 1, pageSize = 20, filters = "") => {
  try {
    const response = await getData(
      eps.allUserslist
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching users list : ", err);
    return null;
  }
};

export const deleteUserById = async (id = 0) => {
  try {
    const response = await getData(eps.deleteUser.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting user by id : ", err);
    return null;
  }
};

export const searchUsersbyQuery = async (
  query = "",
  page = 1,
  pageSize = 20
) => {
  try {
    const response = await getData(
      eps.searchUsers
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon deleting user by id : ", err);
    return null;
  }
};

export const toggleUserStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleUserStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling user status : ", err);
    return null;
  }
};

export const getUserById = async (id = "") => {
  try {
    const response = await getData(eps.userById.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon toggling user by ID : ", err);
    return null;
  }
};

export const blockUserById = async (data = {}) => {
  try {
    const response = await postData(eps.blockUser, data);
    return response;
  } catch (err) {
    console.log("ERROR upon blocking user by ID : ", err);
    return null;
  }
};

export const unBlockUserById = async (id = "") => {
  try {
    const response = await getData(eps.unBlockUser.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon Un-Blocking user by ID : ", err);
    return null;
  }
};

export const fetchCitiesList = async (
  page = 1,
  pageSize = 20,
  filters = ""
) => {
  try {
    const response = await getData(
      eps.allCities
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching cities list : ", err);
    return null;
  }
};

export const addNewCity = async (data = {}) => {
  try {
    const response = await postData(eps.addCity, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding new city : ", err);
    return null;
  }
};

export const updateCity = async (data = {}) => {
  try {
    const response = await postData(eps.updateCity, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a city : ", err);
    return null;
  }
};

export const deleteCityById = async (id = 0) => {
  try {
    const response = await getData(eps.deleteCity.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a city : ", err);
    return null;
  }
};

export const fetchCountriesList = async (
  page = 1,
  pageSize = 20,
  filters = ""
) => {
  try {
    const response = await getData(
      eps.allCountries
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching countries list : ", err);
    return null;
  }
};

export const addNewCountry = async (data = {}) => {
  try {
    const response = await postData(eps.addCountry, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding a new country : ", err);
    return null;
  }
};

export const updateCountry = async (data = {}) => {
  try {
    const response = await postData(eps.updateCountry, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a country : ", err);
    return null;
  }
};

export const deleteCountryById = async (id = 0) => {
  try {
    const response = await getData(eps.deleteCountry.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a country : ", err);
    return null;
  }
};

export const toggleCountryStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleCountryStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Toggling a country status : ", err);
    return null;
  }
};

export const toggleProvinceStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleProvinceStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Toggling a province status : ", err);
    return null;
  }
};

export const toggleCityStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleCityStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Toggling a City status : ", err);
    return null;
  }
};
export const restoreCity = async (id = "") => {
  try {
    const response = await getData(eps.restoreCity.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const restoreCountry = async (id = "") => {
  try {
    const response = await getData(eps.restoreCountry.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const restoreProvince = async (id = "") => {
  try {
    const response = await getData(eps.restoreProvince.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const searchCountries = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchCountries
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon deleting user by id : ", err);
    return null;
  }
};
export const searchProvinces = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchProvinces
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon deleting user by id : ", err);
    return null;
  }
};
export const searchCities = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchCities
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon deleting user by id : ", err);
    return null;
  }
};
////////////////////////////////////////////////////////////////////////

export const fetchProvinceList = async (
  page = 1,
  pageSize = 20,
  filters = ""
) => {
  try {
    const response = await getData(
      eps.allProvinces
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching province list : ", err);
    return null;
  }
};

export const addNewProvince = async (data = {}) => {
  try {
    const response = await postData(eps.addProvince, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding a new province : ", err);
    return null;
  }
};

export const updateProvince = async (data = {}) => {
  try {
    const response = await postData(eps.updateProvince, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a province : ", err);
    return null;
  }
};

export const deleteProvinceById = async (id = 0) => {
  try {
    const response = await getData(eps.deleteProvince.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a province by id : ", err);
    return null;
  }
};

export const fetchProvincesByCountry = async (id = 0) => {
  try {
    const response = await getData(eps.provincesByCountry.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon fetching province By Country : ", err);
    return null;
  }
};
export const fetchCitiesByProvince = async (id = 0) => {
  try {
    const response = await getData(eps.citiesByProvince.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon fetching Cities by province  : ", err);
    return null;
  }
};

export const addNewOrganization = async (data = {}) => {
  try {
    const response = await postData(eps.addCharitableOrg, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding new charitable org : ", err);
    return null;
  }
};

export const updateCharitableOrg = async (data = {}) => {
  try {
    const response = await postData(eps.updateCharitableOrg, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a charitable org : ", err);
    return null;
  }
};

export const fetchCharitableOrgs = async (
  page = 1,
  pageSize = 10,
  filters = ""
) => {
  try {
    const response = await getData(
      eps.getCharitableOrgs
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching charitable orgs list : ", err);
    return null;
  }
};

export const fetchCharitableOrgById = async (id = 0) => {
  try {
    const response = await getData(
      eps.getCharitableOrgById.replace("${id}", id)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a province by id : ", err);
    return null;
  }
};

export const deleteCharitableOrgById = async (id = 0) => {
  try {
    const response = await getData(
      eps.deleteCharitableOrg.replace("${id}", id)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a charitable org by id : ", err);
    return null;
  }
};

export const toggleOrgStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleOrgStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling org status : ", err);
    return null;
  }
};

export const searchCharitableOrg = async (
  query = "",
  page = 1,
  pageSize = 20
) => {
  try {
    const response = await getData(
      eps.searchCharitableOrg
        .replace("${query}", query)
        .concat(`&page=${page}&pageSize=${pageSize}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching charitable orgs : ", err);
    return null;
  }
};

export const uploadOrganizationThumbnail = async (id = 0, data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadOrgThumbnail.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon updating Organization Thumbnail : ", err);
    return null;
  }
};

export const uploadOrganizationImage = async (id = 0, data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadOrgImage.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon updating Organization Image : ", err);
    return null;
  }
};
export const restoreCharitableOrg = async (id = 0, data = {}) => {
  try {
    const response = await getData(
      eps.restoreCharitableOrg.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const createNewAdApi = async (data = {}) => {
  try {
    const response = await postData(eps.addAdsApi, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding a new ad api : ", err);
    return null;
  }
};

export const updateAdApi = async (data = {}) => {
  try {
    const response = await postData(eps.updateAdApi, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating an ad api : ", err);
    return null;
  }
};

export const deleteAdApiById = async (id = 0) => {
  try {
    const response = await getData(eps.deleteAdApiById.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting an ad api : ", err);
    return null;
  }
};

export const fetchAdApis = async (page = 1, pageSize = 10, filters = "") => {
  try {
    const response = await getData(
      eps.getAllAdsApis
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(filters?.length ? `&${filters}` : "")
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Getting Ad apis list : ", err);
    return null;
  }
};

export const toggleAdApiStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleAdApiStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling Ads api status : ", err);
    return null;
  }
};

export const searchAdApi = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchAdsApis
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching Ads apis : ", err);
    return null;
  }
};

export const getAdApiDetails = async (data = {}) => {
  try {
    const response = await postData(eps.adApiDetails, data);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching Ads api details : ", err);
    return null;
  }
};

export const restoreAdApi = async (id = "") => {
  try {
    const response = await getData(eps.restoreAdApi.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const fetchAdUnits = async (id = "") => {
  try {
    const response = await getData(eps.adUnits.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const toggleAdUnitStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleAdUnitStatus, data);
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const newAdUnit = async (data = {}) => {
  try {
    const response = await postData(eps.newAdUnit, data);
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const updateAdUnit = async (data = {}) => {
  try {
    const response = await postData(eps.updateAdUnit, data);
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const deleteAdUnit = async (apiId = "", unitId = "") => {
  try {
    const response = await getData(
      eps.deleteAdUnit.replace("${apiId}", apiId).replace("${unitId}", unitId)
    );
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const addRole = async (data = {}) => {
  try {
    const response = await postData(eps.addNewRole, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding a new role : ", err);
    return null;
  }
};

export const updateRole = async (data = {}) => {
  try {
    const response = await postData(eps.updateRole, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a role : ", err);
    return null;
  }
};

export const fetchRolesList = async (page = 1, pageSize = 10, filters = "") => {
  try {
    const response = await getData(
      eps.getRolesList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Getting role list : ", err);
    return null;
  }
};

export const deleteRoleById = async (id = "") => {
  try {
    const response = await getData(eps.deleteRoleById.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a role : ", err);
    return null;
  }
};

export const toggleRoletatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleRoleStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling Role status : ", err);
    return null;
  }
};

export const searchRoles = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchRoles
        .replace("${query}", query)
        .concat(`&page=${page}&pageSize=${pageSize}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching Roles : ", err);
    return null;
  }
};
////////////////////////////////////////////FAQs Category
export const addNewFAQsCategory = async (data = {}) => {
  try {
    const response = await postData(eps.addNewFAQsCategory, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding a new faq's category : ", err);
    return null;
  }
};

export const updateFAQsCategory = async (data = {}) => {
  try {
    const response = await postData(eps.updateFAQsCategory, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating faq category : ", err);
    return null;
  }
};

export const fetchFAQsCategories = async () => {
  try {
    const response = await getData(eps.getFAQsCategories);
    return response;
  } catch (err) {
    console.log("ERROR upon getting faq categories list : ", err);
    return null;
  }
};

export const deleteFAQsCategoriesById = async (id = "") => {
  try {
    const response = await getData(
      eps.deleteFAQsCategoriesById.replace("${id}", id)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon delete FAQs Categories By Id : ", err);
    return null;
  }
};

export const toggleFAQsCategoryStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleFAQsCategoryStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon delete FAQs Categories By Id : ", err);
    return null;
  }
};

export const searchFAQsCategories = async (query = "") => {
  try {
    const response = await getData(
      eps.searchFAQsCategories.replace("${query}", query)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching FAQs Categories : ", err);
    return null;
  }
};
//////////////////////////////////////////////////////FAQs
export const addNewFAQs = async (data = {}) => {
  try {
    const response = await postData(eps.addNewFAQs, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding New FAQs : ", err);
    return null;
  }
};

export const updateFAQs = async (data = {}) => {
  try {
    const response = await postData(eps.updateFAQs, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a faq : ", err);
    return null;
  }
};

export const fetchFAQsList = async (page = 1, pageSize = 20, filters = "") => {
  try {
    const response = await getData(
      eps.getFAQsList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetch FAQs List : ", err);
    return null;
  }
};

export const deleteFAQById = async (id = "") => {
  try {
    const response = await getData(eps.deleteFAQById.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon delete faq by id : ", err);
    return null;
  }
};

export const toggleFAQStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleFAQStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggle FAQ Status : ", err);
    return null;
  }
};

export const getFAQsByCategoryId = async (id = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.getFAQsByCategoryId
        .replace("${id}", id)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const restoreFAQ = async (id = "") => {
  try {
    const response = await getData(eps.restoreFAQ.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};

////////////////////////////////////////////////////////////////Game
export const addNewGame = async (data = {}) => {
  try {
    const response = await postData(eps.addNewGame, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding a new game : ", err);
    return null;
  }
};

export const updateGame = async (data = {}) => {
  try {
    const response = await postData(eps.updateGame, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a game : ", err);
    return null;
  }
};

export const fetchGamesList = async (page = 1, pageSize = 20, filters = "") => {
  try {
    const response = await getData(
      eps.getGamesList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(filters)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting games list : ", err);
    return null;
  }
};

export const deleteGameById = async (id = "") => {
  try {
    const response = await getData(eps.deleteGameByID.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a game by Id : ", err);
    return null;
  }
};

export const toggleGameStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleGameStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling a game status : ", err);
    return null;
  }
};

export const searchGames = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchGames
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching a game : ", err);
    return null;
  }
};

export const fetchMiscData = async () => {
  try {
    const response = await getData(eps.getMiscData);
    return response;
  } catch (err) {
    console.log("ERROR upon getting games list : ", err);
    return null;
  }
};

export const getGameById = async (id = "") => {
  try {
    const response = await getData(eps.getGameById.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon getting getGame By Id : ", err);
    return null;
  }
};

export const uploadGameImage = async (id = "", data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadGameImage.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Adding game Image : ", err);
    return null;
  }
};
export const uploadGameThumbnail = async (id = "", data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadGameThumbnail.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon adding game icon : ", err);
    return null;
  }
};
export const addGameApiInfo = async (data = {}) => {
  try {
    const response = await postData(eps.addGameApiInfo, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding game Api Info : ", err);
    return null;
  }
};
export const updateGameApiInfo = async (data = {}) => {
  try {
    const response = await postData(eps.updateGameApiInfo, data);
    return response;
  } catch (err) {
    console.log("ERROR upon update game API Info : ", err);
    return null;
  }
};

export const uploadGameFile = async (data = {}) => {
  try {
    const response = await postFormData(eps.uploadGameFile, data);
    return response;
  } catch (err) {
    return err ?? null;
  }
};

export const restoreGame = async (id = "") => {
  try {
    const response = await getData(eps.restoreGame.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};
///////////////////////////////////////////Permissions

export const addNewPermission = async (data = {}) => {
  try {
    const response = await postData(eps.addNewPermission, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding a new permission : ", err);
    return null;
  }
};

export const updatePermission = async (data = {}) => {
  try {
    const response = await postData(eps.updatePermission, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a permission : ", err);
    return null;
  }
};

export const fetchPermissionsList = async (
  page = 1,
  pageSize = 20,
  filters = ""
) => {
  try {
    const response = await getData(
      eps.permissionsList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting permissions list : ", err);
    return null;
  }
};

export const togglePermissionStatus = async (data = {}) => {
  try {
    const response = await postData(eps.togglePermissionStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling permissions status : ", err);
    return null;
  }
};

export const deletePermissionById = async (id = "") => {
  try {
    const response = await getData(eps.deletePermission.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR Upon Deleting Permission By Id : ", err);
    return null;
  }
};

export const searchPermissions = async (
  query = "",
  page = 1,
  pageSize = 20
) => {
  try {
    const response = await getData(
      eps.searchPermission
        .replace("${query}", query)
        .concat(`?page=${page}&pageSize=${pageSize}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching permissions : ", err);
    return null;
  }
};

export const fetchSystemModuleList = async () => {
  try {
    const response = await getData(eps.systemModulesList);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching system module list : ", err);
    return null;
  }
};

///////////////////////////////////////////Role Permissions
export const fetchRolePermissionsList = async () => {
  try {
    const response = await getData(eps.getRolePermissionsList);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching role permissions list : ", err);
    return null;
  }
};

export const fetchRolePermissionsByModules = async (id = "") => {
  try {
    const response = await getData(
      eps.getRolePermissionsByModules.replace("${id}", id)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching Role permissions By Modules : ", err);
    return null;
  }
};

export const addSingleRolePermission = async (data = {}) => {
  try {
    const response = await postData(eps.addSingleRP, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding single Role_Permission : ", err);
    return null;
  }
};

export const removeRolePermission = async (data = {}) => {
  try {
    const response = await postData(eps.removeSingleRP, data);
    return response;
  } catch (err) {
    console.log("ERROR upon removing Role_Permission : ", err);
    return null;
  }
};

export const addBulkRolePermissions = async (data = {}) => {
  try {
    const response = await postData(eps.addBulkRP, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding bulk Role_Permissions : ", err);
    return null;
  }
};

export const removeBulkRolePermissions = async (data = {}) => {
  try {
    const response = await postData(eps.removeBulkRP, data);
    return response;
  } catch (err) {
    console.log("ERROR upon removing bulk Role_Permissions : ", err);
    return null;
  }
};

///////////////////////////////////////////User Permissions
export const fetchUserPermissionsList = async () => {
  try {
    const response = await getData(eps.getUserPermissionsList);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching user permissions list : ", err);
    return null;
  }
};

export const fetchUserPermissionsByModules = async (id = 0) => {
  try {
    const response = await getData(
      eps.getUserPermissionsByModules.replace("${id}", id)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching user permissions by modules : ", err);
    return null;
  }
};

export const addSingleUserPermission = async (data = {}) => {
  try {
    const response = await postData(eps.addSingleUP, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding single user permission : ", err);
    return null;
  }
};

export const removeUserPermission = async (data = {}) => {
  try {
    const response = await postData(eps.removeSingleUP, data);
    return response;
  } catch (err) {
    console.log("ERROR upon removing user permission : ", err);
    return null;
  }
};

export const addBulkUserPermissions = async (data = {}) => {
  try {
    const response = await postData(eps.addBulkUP, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding bulk user permissions : ", err);
    return null;
  }
};

export const removeBulkUserPermissions = async (data = {}) => {
  try {
    const response = await postData(eps.removeBulkUP, data);
    return response;
  } catch (err) {
    console.log("ERROR upon removing bulk user permissions : ", err);
    return null;
  }
};

export const getUserRole = async (id = "") => {
  try {
    const response = await getData(eps.getUserRole.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon getting user role : ", err);
    return null;
  }
};
export const setUserRole = async (data = {}) => {
  try {
    const response = await postData(eps.setUserRole, data);
    return response;
  } catch (err) {
    console.log("ERROR upon setting user role : ", err);
    return null;
  }
};
///////////////////////////////////////////////////////////////////////Reports
/////////////////////////Insights
export const fetchUserStatsDataReport = async () => {
  try {
    const response = await getData(eps.userStatsDataReport);
    return response;
  } catch (err) {
    console.log("ERROR upon getting user Stats Data Report : ", err);
    return null;
  }
};
export const fetchRevenueStatsDataReport = async () => {
  try {
    const response = await getData(eps.revenueStatsDataReport);
    return response;
  } catch (err) {
    console.log("ERROR upon getting revenue Stats Data Report: ", err);
    return null;
  }
};
export const fetchDonationsStatsDataReport = async () => {
  try {
    const response = await getData(eps.donationsStatsDataReport);
    return response;
  } catch (err) {
    console.log("ERROR upon getting donations Stats Data Report: ", err);
    return null;
  }
};
export const fetchGamesStatsDataReport = async () => {
  try {
    const response = await getData(eps.gamesStatsDataReport);
    return response;
  } catch (err) {
    console.log("ERROR upon getting games Stats Data Report: ", err);
    return null;
  }
};
export const fetchRegisteredGamesReport = async () => {
  try {
    const response = await getData(eps.registeredGamesReport);
    return response;
  } catch (err) {
    console.log("ERROR upon getting registered Games Report: ", err);
    return null;
  }
};
export const fetchTotalTraficReport = async () => {
  try {
    const response = await getData(eps.totalTraficReport);
    return response;
  } catch (err) {
    console.log("ERROR upon getting total Trafic Report: ", err);
    return null;
  }
};
export const fetchQuarterlyRevenueReport = async () => {
  try {
    const response = await getData(eps.quarterlyRevenueReport);
    return response;
  } catch (err) {
    console.log("ERROR upon getting games quarterly Revenue Report ", err);
    return null;
  }
};
export const fetchPastWeekDonationsReport = async () => {
  try {
    const response = await getData(eps.pastWeekDonationsReport);
    return response;
  } catch (err) {
    console.log("ERROR upon getting past Week Donations Report ", err);
    return null;
  }
};
export const fetchToppersReportDataReport = async () => {
  try {
    const response = await getData(eps.toppersReportDataReport);
    return response;
  } catch (err) {
    console.log("ERROR upon getting games toppers Report Data Report ", err);
    return null;
  }
};
///////////////////////////////////////////For Reports Pages
export const fetchadsCountByGames = async (range, type) => {
  try {
    const response = await getData(
      eps.adsCountByGames.replace("${range}", range).replace("${type}", type)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting Reports data : ", err);
    return null;
  }
};
export const fetchadsCountByGames12Months = async () => {
  try {
    const response = await getData(eps.adsCountByGames12Months);
    return response;
  } catch (err) {
    console.log("ERROR upon getting Reports data : ", err);
    return null;
  }
};
export const fetchAdFillReport = async () => {
  try {
    const response = await getData(eps.adFillReport);
    return response;
  } catch (err) {
    console.log("ERROR upon ad fill reports data : ", err);
    return null;
  }
};
export const fetchAdViewsByUserType = async () => {
  try {
    const response = await getData(eps.adViewsByUserType);
    return response;
  } catch (err) {
    console.log("ERROR upon ad views by user type : ", err);
    return null;
  }
};
export const fetchAdViewsBySessionLength = async () => {
  try {
    const response = await getData(eps.adViewsBySessionLength);
    return response;
  } catch (err) {
    console.log("ERROR upon ad Views By Session Length : ", err);
    return null;
  }
};
export const fetchHighValueUsers = async (page = 1, pageSize = 10) => {
  try {
    const response = await getData(
      eps.highValueUsers
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting high value users : ", err);
    return null;
  }
};
export const fetchRetentionRate = async (
  range = 1,
  page = 1,
  pageSize = 10
) => {
  try {
    const response = await getData(
      eps.retentionRate
        .replace("${range}", range)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting retention rate : ", err);
    return null;
  }
};
export const fetchAdsByGames = async (page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.adsByGames.replace("${page}", page).replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting ads count by games : ", err);
    return null;
  }
};

export const fetchAdViewsThreeHourly = async () => {
  try {
    const response = await getData(eps.adViewsThreeHourly);
    return response;
  } catch (err) {
    console.log("ERROR upon fetch Ad Views ThreeHourly : ", err);
    return null;
  }
};
export const fetchAdViewsDaily = async () => {
  try {
    const response = await getData(eps.adViewsDaily);
    return response;
  } catch (err) {
    console.log("ERROR upon fetch Ad Views Daily : ", err);
    return null;
  }
};
export const fetchAdViewsHourly = async () => {
  try {
    const response = await getData(eps.adViewsHourly);
    return response;
  } catch (err) {
    console.log("ERROR upon fetch Ad Views Hourly : ", err);
    return null;
  }
};
export const fetchAdsOnSpecialEvents = async (page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.adsOnSpecialEvents
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon ads On Special Events : ", err);
    return null;
  }
};
export const fetchFillErrorsByAdType = async () => {
  try {
    const response = await getData(eps.fillErrorsByAdType);
    return response;
  } catch (err) {
    console.log("ERROR upon fill Errors By Ad Type : ", err);
    return null;
  }
};
export const fetchAdsCountByPlatform = async () => {
  try {
    const response = await getData(eps.adsCountByPlatform);
    return response;
  } catch (err) {
    console.log("ERROR upon ads Count By Platform : ", err);
    return null;
  }
};

export const fetchAdsCountByCountries = async (page = 1, pageSize = 10) => {
  try {
    const response = await getData(
      eps.adsCountByCountries
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon ads Count By Countries : ", err);
    return null;
  }
};

export const fetchComplaintsAboutAds = async () => {
  try {
    const response = await getData(eps.complaintsAboutAds);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching Complaints About Ads : ", err);
    return null;
  }
};
export const fetchAdsSkipRate = async () => {
  try {
    const response = await getData(eps.adsSkipRate);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching ads Skip Rate : ", err);
    return null;
  }
};
export const fetchAdsCountByProviders = async (range) => {
  try {
    const response = await getData(
      eps.adsCountByProviders.replace("${range}", range)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching ads Count By Providers : ", err);
    return null;
  }
};

export const fetchRetentionRateByAdCapping = async () => {
  try {
    const response = await getData(eps.retentionRateByAdCapping);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching retention Rate By Ad Capping : ", err);
    return null;
  }
};

export const fetchAdsCountByAdsPlacement = async () => {
  try {
    const response = await getData(eps.adsCountByAdsPlacement);
    return response;
  } catch (error) {
    console.log("Error getting Ads count by ad placement :", error);
    return null;
  }
};

export const fetchBlockedAdsData = async (range = "weekly") => {
  try {
    const response = await getData(
      eps.blockedAdsData.replace("${range}", range)
    );
    return response;
  } catch (error) {
    console.log("Error upon getting blocked ad data");
    return null;
  }
};

export const fetchBotActivities = async () => {
  try {
    const response = await getData(eps.botActivities);
    return response;
  } catch (error) {
    console.log("Error upon getting bot activities");
    return null;
  }
};
///////////////////////////////////////////////////////////////////////Achievements
export const addNewAchievement = async (data = {}) => {
  try {
    const response = await postData(eps.addAchievement, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Adding new achievement : ", err);
    return null;
  }
};
export const updateAchievement = async (data = {}) => {
  try {
    const response = await postData(eps.updateAchievement, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating an achievement : ", err);
    return null;
  }
};
export const deleteAchievementById = async (id = "") => {
  try {
    const response = await getData(eps.deleteAchievement.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting an achievement : ", err);
    return null;
  }
};
export const fetchAchievementList = async () => {
  try {
    const response = await getData(eps.achievementList);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching achievements list : ", err);
    return null;
  }
};
export const paginatedAchievementList = async (
  page = 1,
  pageSize = 10,
  filters = ""
) => {
  try {
    const response = await getData(
      eps.paginatedAchievementList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching paginated Achievement List : ", err);
    return null;
  }
};
export const toggleAchievementStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleAchievementStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon getting Reports data : ", err);
    return null;
  }
};
export const searchAchievements = async (
  query = "",
  page = 1,
  pageSize = 20
) => {
  try {
    const response = await getData(
      eps.searchAchievement
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting Reports data : ", err);
    return null;
  }
};
export const restoreAchievemnet = async (id = "") => {
  try {
    const response = await getData(eps.restoreAchievemnet.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};
export const uploadAchievementIcon = async (id = "", data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadAchievementIcon.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting Reports data : ", err);
    return null;
  }
};
////////////////////////////////////////////////////////////////////////////
export const addNewBadge = async (data = {}) => {
  try {
    const response = await postData(eps.addBadge, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding a new badge : ", err);
    return null;
  }
};
export const updateBadge = async (data = {}) => {
  try {
    const response = await postData(eps.updateBadge, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Updating a badge : ", err);
    return null;
  }
};
export const deleteBadgeById = async (id = "") => {
  try {
    const response = await getData(eps.deleteBadge.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a badge : ", err);
    return null;
  }
};
export const fetchBadgesList = async () => {
  try {
    const response = await getData(eps.badgesList);
    return response;
  } catch (err) {
    console.log("ERROR upon getting Raw Badges List : ", err);
    return null;
  }
};
export const fetchPaginatedBadgesList = async (
  page = 1,
  pageSize = 10,
  filters = ""
) => {
  try {
    const response = await getData(
      eps.paginatedBadgesList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting Paginated Badges List : ", err);
    return null;
  }
};
export const toggleBadgeStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleBadgeStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling Badge Status : ", err);
    return null;
  }
};
export const searchBadges = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchBadges
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Searching Badges : ", err);
    return null;
  }
};
export const uploadBadgeIcon = async (id = "", data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadBadgeIcon.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon uploading Badge Icon : ", err);
    return null;
  }
};
export const restoreBadge = async (id = "") => {
  try {
    const response = await getData(eps.restoreBadge.replace("${id}", id));
    return response;
  } catch (err) {
    return err ?? null;
  }
};
/////////////////////////////////////////////////////////Feedbacks
export const fetchPaginatedFeedback = async (
  page = 1,
  pageSize = 10,
  filters = ""
) => {
  try {
    const response = await getData(
      eps.getPaginatedFeedback
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(`&${filters}`)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting paginated feedbacks : ", err);
    return null;
  }
};

export const searchfeedbacks = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchfeedbacks
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching feedbacks : ", err);
    return null;
  }
};

export const fetchFeedbackCategories = async () => {
  try {
    const response = await getData(eps.getFeedbackCategories);
    return response;
  } catch (err) {
    console.log("ERROR upon Getting feedback categories : ", err);
    return null;
  }
};

export const respondAFeedback = async (data = {}) => {
  try {
    const response = await postData(eps.respondFeedback, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Sending a feedback response : ", err);
    return null;
  }
};

export const getPaginatedContactUs = async (
  page = 1,
  pageSize = 10,
  filters = ""
) => {
  try {
    const response = await getData(
      eps.getPaginatedContactUs
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .concat(filters?.length ? `&${filters}` : "")
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching paginated contact us list : ", err);
    return null;
  }
};
export const searchContactUs = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchContactUs
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon serching contact us list : ", err);
    return null;
  }
};
export const getContactUsCategories = async () => {
  try {
    const response = await getData(eps.getContactUsCategories);
    return response;
  } catch (err) {
    console.log("ERROR upon getting contact us categories : ", err);
    return null;
  }
};

export const respondAContactUs = async (data = {}) => {
  try {
    const response = await postData(eps.respondContactUs, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Sending a Contact Us response : ", err);
    return null;
  }
};

///////////////////////////////////////////////////Game Categories
export const getGameCatsList = async () => {
  try {
    const response = await getData(eps.getGCList);
    return response;
  } catch (err) {
    console.log("ERROR upon getting game categories : ", err);
    return null;
  }
};

export const getPaginatedGCList = async (page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.getPaginatedGCList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting paginated game categories : ", err);
    return null;
  }
};

export const deleteCategoryById = async (id = "") => {
  try {
    const response = await getData(eps.deleteCategory.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting game category : ", err);
    return null;
  }
};

export const toggleCategoryStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleCategoryStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggeling game categories status : ", err);
    return null;
  }
};

export const searchCategories = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchCategories
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching game categories : ", err);
    return null;
  }
};

export const addNewCategory = async (data = {}) => {
  try {
    const response = await postData(eps.addNewCategory, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding new game category : ", err);
    return null;
  }
};

export const editCategory = async (data = {}) => {
  try {
    const response = await postData(eps.editCategory, data);
    return response;
  } catch (err) {
    console.log("ERROR upon editing game category : ", err);
    return null;
  }
};

export const uploadCatImage = async (id = "", data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadCatImage.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Uploading Category Image : ", err);
    return null;
  }
};

///////////////////////////////////////////////////Game Sub-Categories
export const getGameSubCatsList = async () => {
  try {
    const response = await getData(eps.getSCList);
    return response;
  } catch (err) {
    console.log("ERROR upon getting game sub cats list : ", err);
    return null;
  }
};

export const getGameSubCatById = async (id = "") => {
  try {
    const response = await getData(eps.getSCByCatId.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon getting game sub cats by id : ", err);
    return null;
  }
};

export const getSubCatPaginatedList = async (page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.getPaginatedList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting paginted game sub cats : ", err);
    return null;
  }
};

export const deleteSubCategoryById = async (id = "") => {
  try {
    const response = await getData(eps.deleteSubCategory.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting game sub cats by id : ", err);
    return null;
  }
};

export const toggleSubCatStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleSubCatStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling game sub cat status : ", err);
    return null;
  }
};

export const searchSubCats = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchSubCats
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching game sub cats : ", err);
    return null;
  }
};

export const addNewSubCat = async (data = {}) => {
  try {
    const response = await postData(eps.addNewSubCat, data);
    return response;
  } catch (err) {
    console.log("ERROR upon ading new game sub category : ", err);
    return null;
  }
};

export const editSubCat = async (data = {}) => {
  try {
    const response = await postData(eps.editSubCat, data);
    return response;
  } catch (err) {
    console.log("ERROR upon editing game sub category: ", err);
    return null;
  }
};
export const getPaginatedListByCategory = async (
  id = "",
  page = 1,
  pageSize = 20
) => {
  try {
    const response = await getData(
      eps.getPaginatedListByCategory
        .replace("${id}", id)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log(
      "ERROR upon getting pginated sub category list by category: ",
      err
    );
    return null;
  }
};

//////////////////////////////////////////////////////Game Tags
export const getGameTags = async () => {
  try {
    const response = await getData(eps.getGameTags);
    return response;
  } catch (err) {
    console.log("ERROR upon getting All game-tags : ", err);
    return null;
  }
};

export const getPaginatedGameTags = async (page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.getPaginatedTags
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting paginated game Tags : ", err);
    return null;
  }
};

export const changeTagStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleTagStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon changing tag status : ", err);
    return null;
  }
};

export const deleteTagById = async (id = "") => {
  try {
    const response = await getData(eps.deleteTag.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting tag : ", err);
    return null;
  }
};

export const searchTags = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchTags
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching tags : ", err);
    return null;
  }
};

export const addNewGameTag = async (data = {}) => {
  try {
    const response = await postData(eps.addNewTag, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding new game tag : ", err);
    return null;
  }
};

export const editGameTag = async (data = {}) => {
  try {
    const response = await postData(eps.editTag, data);
    return response;
  } catch (err) {
    console.log("ERROR upon editing a game tag : ", err);
    return null;
  }
};

// // // ///////////////////////////////// Custom pages
export const fetchPageContentList = async (
  pageCode = "",
  page = 1,
  pageSize = 5
) => {
  try {
    const response = await getData(
      eps.pageContentList
        .replace("${pageCode}", pageCode)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching pages and content : ", err);
    return null;
  }
};

export const togglePageStatus = async (data = {}) => {
  try {
    const response = await postData(eps.togglePageStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling Page status : ", err);
    return null;
  }
};

export const deletePageById = async (id = "") => {
  try {
    const response = await getData(eps.deletePageById.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a page : ", err);
    return null;
  }
};

export const getAllPagesList = async () => {
  try {
    const response = await getData(eps.getPagesList);
    return response;
  } catch (err) {
    console.log("ERROR upon getting all pages list : ", err);
    return null;
  }
};

export const addPageContent = async (data = {}) => {
  try {
    const response = await postData(eps.addPageContent, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Adding a new page content : ", err);
    return null;
  }
};

export const updatePage = async (data = {}) => {
  try {
    const response = await postData(eps.updatePage, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a page content : ", err);
    return null;
  }
};

export const fetchBannersData = async () => {
  try {
    const response = await getData(eps.getBannerData);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching Banner page Data : ", err);
    return null;
  }
};

export const saveBannerImage = async (id = "", data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadBannerImage.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Saving banner images : ", err);
    return null;
  }
};

export const addNewBanner = async (data = {}) => {
  try {
    const response = await postData(eps.addNewBanner, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Adding new banner : ", err);
    return null;
  }
};

export const updatedBanner = async (data = {}) => {
  try {
    const response = await postData(eps.updatedBanner, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating banner : ", err);
    return null;
  }
};

export const deleteBanner = async (id = "") => {
  try {
    const response = await getData(eps.deleteBanner.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting banner : ", err);
    return null;
  }
};

export const fetchAboutUsPage = async () => {
  try {
    const response = await getData(eps.getAboutUsPage);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching about us page data : ", err);
    return null;
  }
};

export const uploadCustomPageMedia = async (data = {}) => {
  try {
    const response = await postFormData(eps.uploadPageMedia, data);
    return response;
  } catch (err) {
    console.log("ERROR upon uploading custom page media : ", err);
    return null;
  }
};

export const updateAboutUsPage = async (data = {}) => {
  try {
    const response = await postData(eps.updateAboutUsPage, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating about us page : ", err);
    return null;
  }
};

export const fetchEntities = async (module = "") => {
  try {
    const response = await getData(
      eps.entitiesforBanner.replace("${module}", module)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon fetching entities for banners : ", err);
    return null;
  }
};

////////////////////////////////////////////////////Game Providers
export const getAllProviders = async () => {
  try {
    const response = await getData(eps.getAllProviders);
    return response;
  } catch (err) {
    console.log("ERROR upon getting all providers : ", err);
    return null;
  }
};
export const paginatedProvidersList = async (page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.paginatedProvidersList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting providers paginated list : ", err);
    return null;
  }
};
export const addNewProvider = async (data = {}) => {
  try {
    const response = await postData(eps.addNewProvider, data);
    return response;
  } catch (err) {
    console.log("ERROR upon adding new provider : ", err);
    return null;
  }
};
export const updateProvider = async (data = {}) => {
  try {
    const response = await postData(eps.updateProvider, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating provider data : ", err);
    return null;
  }
};
export const toggleProviderStatus = async (data = {}) => {
  try {
    const response = await postData(eps.toggleProviderStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon toggling providers status : ", err);
    return null;
  }
};
export const deleteProviderById = async (id = "") => {
  try {
    const response = await getData(eps.deleteProvider.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting provider by ID : ", err);
    return null;
  }
};
export const searchProviders = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchProviders
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon searching provider : ", err);
    return null;
  }
};
export const uploadProvidersImage = async (id = "", data = {}) => {
  try {
    const response = await postFormData(
      eps.uploadProvidersImage.replace("${id}", id),
      data
    );
    return response;
  } catch (err) {
    console.log("ERROR upon uploading providers logo : ", err);
    return null;
  }
};
/////////////////////////////////////////////////////////////////////////////////Game Bugs
export const getPaginatedGameBugs = async (page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.gameBugsList.replace("${page}", page).replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting Game Bugs paginated list : ", err);
    return null;
  }
};
export const changeBugStatus = async (data = {}) => {
  try {
    const response = await postData(eps.changeBugStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Changing Bug status : ", err);
    return null;
  }
};

export const searchGameBugs = async (query = "", page = 1, pageSize = 20) => {
  try {
    const response = await getData(
      eps.searchGameBugs
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
        .replace("${query}", query)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Searching Bugs: ", err);
    return null;
  }
};

export const fetchPaginatedReviews = async (page = 1, pageSize = 30) => {
  try {
    const response = await getData(
      eps.paginatedReviews
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon getting Game Reviews paginated list : ", err);
    return null;
  }
};

export const searchReviewsByQuery = async (
  query = "",
  page = 1,
  pageSize = 50
) => {
  try {
    const response = await getData(
      eps.searchReviews
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Searching Game Reviews  : ", err);
    return null;
  }
};

export const searchReviewsByStatus = async (
  status = "",
  page = 1,
  pageSize = 50
) => {
  try {
    const response = await getData(
      eps.searchByStatus
        .replace("${status}", status)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Searching Game Reviews By Status : ", err);
    return null;
  }
};

export const updateReviewStatus = async (data = {}) => {
  try {
    const response = await postData(eps.updateReviewStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating Game Reviews Status : ", err);
    return null;
  }
};

export const getPaginatedNotifs = async (page = 1, pageSize = 30) => {
  try {
    const response = await getData(
      eps.notificationsList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon updating Game Reviews Status : ", err);
    return null;
  }
};

export const fetchUsersListForNotifs = async () => {
  try {
    const response = await getData(eps.usersListForNotifs);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching users list for notifs : ", err);
    return null;
  }
};

export const fetchEmployeesListForNotifs = async () => {
  try {
    const response = await getData(eps.employeesListForNotifs);
    return response;
  } catch (err) {
    console.log("ERROR upon fetching Employees list for notifs : ", err);
    return null;
  }
};

export const createNewNotification = async (data = {}) => {
  try {
    const response = await postData(eps.addNotification, data);
    return response;
  } catch (err) {
    console.log("ERROR upon Creating a new notification : ", err);
    return null;
  }
};

export const deleteNotification = async (id = "") => {
  try {
    const response = await getData(eps.deleteNotification.replace("${id}", id));
    return response;
  } catch (err) {
    console.log("ERROR upon deleting a notification : ", err);
    return null;
  }
};

export const searchNotifications = async (
  query = "",
  page = 1,
  pageSize = 50
) => {
  try {
    const response = await getData(
      eps.searchNotifications
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Searching notification : ", err);
    return null;
  }
};

export const searchNotifsByStatus = async (
  query = "",
  page = 1,
  pageSize = 50
) => {
  try {
    const response = await getData(
      eps.searchNotifsByStatus
        .replace("${query}", query)
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (err) {
    console.log("ERROR upon Searching notification : ", err);
    return null;
  }
};

export const editNotification = async (data = {}) => {
  try {
    const response = await postData(eps.editNotification, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a notification : ", err);
    return null;
  }
};

export const updateNotifStatus = async (data = {}) => {
  try {
    const response = await postData(eps.updateNotifStatus, data);
    return response;
  } catch (err) {
    console.log("ERROR upon updating a notification status : ", err);
    return null;
  }
};

/////////////////////////////////////////////////////////Admin Notifications
export const getAdminNotifsCount = async () => {
  try {
    const response = await getData(eps.getUnreadCount);
    return response;
  } catch (error) {
    return error ?? null;
  }
};

export const fetchNotificationsList = async (page = 1, pageSize = 50) => {
  try {
    const response = await getData(
      eps.notificationList
        .replace("${page}", page)
        .replace("${pageSize}", pageSize)
    );
    return response;
  } catch (error) {
    return error ?? null;
  }
};

export const markOneNotifAsRead = async (id) => {
  try {
    const response = await getData(eps.markOneAsRead.replace("${id}", id));
    return response;
  } catch (error) {
    return error ?? null;
  }
};

export const markAllNotifAsRead = async () => {
  try {
    const response = await getData(eps.markAllAsRead);
    return response;
  } catch (error) {
    return error ?? null;
  }
};
